import { snackbar } from "@lxc/app-device-common";

const DO_NOT_CLOSE_DURATION = 0;
const SNACKBARS_START_TOP = 88; // Header component default height (72px) + margin (16px)

export enum NotificationKey {
  success = "notification.success.default",
  error = "notification.error.default",
  certificateGenerationSuccess = "notification.success.certificate.generation",
  certificateParsingError = "notification.error.certificate.parsing",
  cancel = "notification.cancellation.cancel",
  saveSuccess = "notification.success.save",
  saveError = "notification.error.save",
  uploadError = "notification.error.upload",
  removeSuccess = "notification.success.remove",
  detachSuccess = "notification.success.detach",
  attachSuccess = "notification.success.attach",
  removeError = "notification.error.remove",
  detachError = "notification.error.detach",
  attachError = "notification.error.attach",
  startDateError = "notification.error.startDate",
}

export function showNotificationError(
  title: string,
  message?: string,
  doNotClose = true,
): void {
  snackbar.error({
    title,
    message,
    duration: doNotClose ? DO_NOT_CLOSE_DURATION : undefined,
    dangerouslyUseHTMLString: true,
    startTop: SNACKBARS_START_TOP,
  });
}

export function showNotificationWarning(
  title: string,
  message?: string,
  doNotClose = true,
): void {
  snackbar.warning({
    title,
    message,
    duration: doNotClose ? DO_NOT_CLOSE_DURATION : undefined,
    startTop: SNACKBARS_START_TOP,
  });
}

export function showNotificationSuccess(title: string, message?: string): void {
  snackbar.success({
    title,
    message,
    dangerouslyUseHTMLString: true,
    startTop: SNACKBARS_START_TOP,
  });
}

/**
 * Format the elements of a list in order to be displayed as an HTML <ul>/<li> list.
 * To be used as parameter of the function "map" of the list, example:
 * ```
 *   errors.map(setDetailMessageAsListItem).join("");
 * ```
 * If the list contains only one element, <ul>/<li> are omitted.
 * @param message
 * @param idx
 * @param details
 * @returns
 */
export function setDetailMessageAsListItem(
  message: string,
  idx: number,
  details: string[],
): string {
  return details.length === 1
    ? message
    : `${idx === 0 ? "<ul>" : ""}<li>${message}</li>${idx === details?.length ? "</ul>" : ""}`;
}
